import React from "react";
import { Form, Button, Divider, Upload, Icon, Row, Col } from "antd";

import RecipientList from "./RecipientList";
import FormInput from "../common/FormInput";
import {
  RecipientFields as Fields,
  UploadCSVGroupFields as GroupFields
} from "../common/labels/forms";

const { Dragger } = Upload;

const AddRecipient = props => {
  const uploaderProps = {
    action: "//jsonplaceholder.typicode.com/posts/",
    beforeUpload: props.onChange,
    accept: "text/csv"
  };

  return (
    <div style={{ marginTop: 40 }}>
      <h2>Recipients</h2>
      <p style={{ marginTop: 40 }}>Add uploaded recipients to a group</p>
      <Row>
        <Col span={5}>
          {GroupFields &&
            GroupFields.map((field, index) => (
              <FormInput
                key={index}
                field={field}
                getFieldDecorator={props.getFieldDecorator}
                onChangeUploadGroup={props.onChangeUploadGroup}
              />
            ))}
        </Col>
      </Row>
      <Dragger {...uploaderProps}>
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">
          Click or drag CSV file to this area to upload
        </p>
      </Dragger>
      <Form
        layout="inline"
        onSubmit={props.addRecipient}
        className="campaign-form"
        style={{ marginTop: 40, marginBottom: 35 }}
      >
        <Divider />
        <p>Add your recipient manually</p>
        {Fields &&
          Fields.map((field, index) => (
            <FormInput
              key={index}
              field={field}
              getFieldDecorator={props.getFieldDecorator}
            />
          ))}
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Add Recipient
          </Button>
        </Form.Item>
      </Form>
      <Divider />
      <RecipientList
        recipients={props.recipients}
        columns={props.columns}
        rowSelection={props.rowSelection}
        state={props.state}
        onOpen={props.onOpen}
        onClose={props.onClose}
        modalState={props.modalState}
        confirm={props.confirm}
        url={props.url}
        handleSearch={props.handleSearch}
        selectDropDownChange={props.selectDropDownChange}
      />
    </div>
  );
};

export default AddRecipient;
